<!-- begin::Footer -->
<footer class="m-grid__item		m-footer" appunwraptag="">
	<div class="m-container m-container--fluid m-container--full-height m-page__container">
		<div class="m-stack m-stack--flex-tablet-and-mobile m-stack--ver m-stack--desktop">
			<div class="m-stack__item m-stack__item--left m-stack__item--middle m-stack__item--last">
				<span class="m-footer__copyright">
					{{year}} &copy; 
					<a [attr.href]="url" target="_blank" class="m-link">
						{{footerText}}
					</a>
				</span>
			</div>
			<div class="m-stack__item m-stack__item--right m-stack__item--middle m-stack__item--first">
				<ul class="m-footer__nav m-nav m-nav--inline m--pull-right">
					<li class="m-nav__item m-nav__item">
						<a href="mailto:efaturadestek@vbt.com.tr?Subject=Destek%20Çağrısı" class="m-nav__link" data-toggle="m-tooltip" title="Destek" data-placement="left">
							<i class="m-nav__link-icon flaticon-info m--icon-font-size-lg3"></i>
						</a>
					</li>
				</ul>
			</div>
		</div>
	</div>
</footer>
<!-- end::Footer -->
